import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /**
     * Cancels a pending stop by clearing the {@link State.stoppingProcessId}
     */
    cancelStop: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => ({
        ...state,
        stoppingProcessId: undefined,
      }),
    }),
    /**
     * Marks a process for stopping (opens the stop confirmation dialog)
     */
    markForStop: store.actions.standalone({
      data: store.actions.Data.asIs<{
        readonly processId: ents.core.relay.processes.Process.Id
      }>(),
      reducer: ({ state, data: { processId } }) => ({
        ...state,
        stoppingProcessId: processId,
      }),
    }),
    /**
     * Stops a running process by terminating its ECS task
     */
    stopProcess: store.actions.request({
      input: store.actions.Data.asIs<{
        readonly processId: ents.core.relay.processes.Process.Id
      }>(),
      output: store.actions.Data.asIs<void>(),
      reducers: {
        cancellation: ({ state }) => ({
          ...state,
          stoppingProcessId: undefined,
        }),
        error: ({ state }) => ({
          ...state,
          stoppingProcessId: undefined,
        }),
        success: ({ state }) => ({
          ...state,
          stoppingProcessId: undefined,
        }),
      },
    }),
    toggleExpand: store.actions.standalone({
      data: store.actions.Data.asIs<{
        readonly processId: ents.core.relay.processes.Process.Id
      }>(),
      reducer: ({ state, data: { processId } }) => ({
        ...state,
        expandLookup: {
          ...state.expandLookup,
          [processId]: state.expandLookup[processId]
            ? !state.expandLookup[processId]
            : true, // Default to true if undefined
        },
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
